export const ROUTE_PATHS = {
  HOME: '/',
  PRODUCTS: '/products/:category',
  CART: '/cart',
} as const;

export const NAV_ITEMS = [
  { label: 'Cartridge Needles', path: '/products/cartridges' },
  { label: 'Tattoo Ink', path: '/products/ink' },
  { label: 'Machines', path: '/products/machines' },
  { label: 'Post-Tattoo Preparation', path: '/products/aftercare' },
  { label: 'Pigments', path: '/products/ink' },
  { label: 'Tools', path: '/products/stencils' },
  { label: 'Studio Equipment', path: '/products/equipment' },
  { label: 'Brands', path: '/products/brands' },
  { label: 'News', path: '/news' },
  { label: 'Promotions', path: '/promotions' },
  { label: 'Contact', path: '/contact' },
] as const;

export const PRODUCT_CATEGORIES = [
  'stencils',
  'cartridges',
  'ink',
  'aftercare',
] as const;

export type Category = typeof PRODUCT_CATEGORIES[number];

export interface Product {
  id: string;
  name: string;
  category: Category;
  price: number;
  image: string;
  description: string;
  rating: number;
  reviewCount: number;
}